(()=>{
 const selector='[data-ek-product-description],[data-ekf-description]';
 const manufacturer=/^\s*Manufactured\s*\/\s*Imported\s*\/\s*Marketed\s*by\s*:\s*.+$/i;
 const address=/^\s*Address\s*:\s*.+$/i;
 const label=/Manufactured\s*\/\s*Imported\s*\/\s*Marketed\s*by\s*:/i;
 const clean=description=>{
  if(!description.isConnected)return;
  const copiedChat=description.querySelector('#thread,#prompt-textarea,.group\\/composer,[class*="text-message"]');
  const prose=[...description.querySelectorAll('.markdown')].filter(node=>node.textContent.trim());
  if(copiedChat&&prose.length){
   const fragments=prose.map(node=>{const fragment=document.createDocumentFragment();[...node.childNodes].forEach(child=>fragment.append(child.cloneNode(true)));return fragment;});
   description.replaceChildren(...fragments);
  }
  description.querySelectorAll('form,input,textarea,button,script,style,[contenteditable],#thread-bottom-container').forEach(node=>node.remove());
  const blocks=[...description.querySelectorAll('p,li,td,div,span')];
  const hasSupplier=label.test(description.textContent);
  blocks.forEach(el=>{
   if(el.hasAttribute('data-ek-disclosure-hidden')||el.querySelector('p,li,div,table,ul,ol,h1,h2,h3,h4,h5,h6,img,video,iframe'))return;
   const text=el.textContent.replace(/\s+/g,' ').trim();
   if(manufacturer.test(text)||(hasSupplier&&address.test(text))){
    el.hidden=true;el.style.setProperty('display','none','important');el.dataset.ekDisclosureHidden='true';
   }
  });
 };
 const rootsFor=node=>{
  const el=node.nodeType===1?node:node.parentElement;if(!el)return [];
  const closest=el.closest(selector);return closest?[closest]:[...el.querySelectorAll(selector)];
 };
 const observer=new MutationObserver(records=>{
  const roots=new Set();records.forEach(record=>{
   rootsFor(record.target).forEach(root=>roots.add(root));
   record.addedNodes.forEach(node=>rootsFor(node).forEach(root=>roots.add(root)));
  });
  observer.disconnect();roots.forEach(clean);observe();
 });
 const observe=()=>observer.observe(document.body,{childList:true,subtree:true,characterData:true});
 const start=()=>{document.querySelectorAll(selector).forEach(clean);observe();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
